import { TenantPlatform } from './TenantPlatform.js';
import { TenantPlatformCountry } from './TenantPlatformCountry.js';
import { PlatAndPlatCountryToTenant } from './PlatAndPlatCountryToTenant.js';

/**
 * Tenants representation model
 *
 */
class Tenant {
  /**
   * Returns a new Tenant.
   *
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Map the Tenant to the legacy platform
   */
  mapToPlatform() {
    const hasPlatform = value => {
      return !!Object.keys(TenantPlatform).find(key => key === value);
    };
    if (this.name && hasPlatform(this.name)) {
      return TenantPlatform[this.name];
    }
    throw new Error('Cannot map to platform');
  }

  /**
   * Map the Tenant to the legacy platform country
   */
  mapToPlatformCountry() {
    const hasPlatformCountry = value => {
      return !!Object.keys(TenantPlatformCountry).find(key => key === value);
    };
    if (this.name && hasPlatformCountry(this.name)) {
      return TenantPlatformCountry[this.name];
    }
    throw new Error('Cannot map to platform country');
  }
  static mapPlatAndPlatCountryToTenant(platform, platformCountry) {
    const tenantName = PlatAndPlatCountryToTenant[platform.toUpperCase()][platformCountry.toUpperCase()];
    if (tenantName) {
      return new Tenant(tenantName);
    }
    throw new Error(`Cannot map platform "${platform}" and platform country "${platformCountry}" to tenant`);
  }
}

export { Tenant };
//# sourceMappingURL=Tenant.js.map
